import React from "react";
import { BRICKS } from "@titelmedia/bricks";

const Credits = props => {
  return (
    <BRICKS.elements.Credits {...props} />
  );
};

export default Credits;
